import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community';
import { FormsModule } from '@angular/forms';

import { FilterOption } from '../../../../core/models/grid/filter-option';

@Component({
    selector: 'app-multi-select-filter',
    templateUrl: './multi-select-filter.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule],
})
export class MultiSelectFilterComponent implements IFilterAngularComp {
    public params!: IFilterParams;
    @Input() filterOptions: FilterOption[] = [];

    agInit(params: IFilterParams): void {
        this.params = params;
        if (params.colDef.filterParams) {
            this.filterOptions = params.colDef.filterParams.filterOptions;
        }
    }

    isFilterActive(): boolean {
        return this.filterOptions.some((option) => option.selected);
    }

    doesFilterPass(params: IDoesFilterPassParams): boolean {
        const selectedValues = this.filterOptions
            .filter((option) => option.selected)
            .map((option) => option.value);
        const value = this.params.getValue(params.node);
        return selectedValues.includes(value);
    }

    getModel(): string[] {
        return this.filterOptions
            .filter((option) => option.selected)
            .map((option) => option.value);
    }

    setModel(model: string[]): void {
        this.filterOptions.forEach((option) => {
            option.selected = model ? model.includes(option.value) : false;
        });
    }

    onFilterChanged(): void {
        this.params.filterChangedCallback();
    }
}
